import { getGuaranteeStatusColor } from './collateralUtils';

const LABELS: Record<string, string> = {
    NOT_STARTED: 'Não iniciado',
    IN_PROGRESS: 'Em andamento',
    CHECKED: 'Conferido',
    DONE: 'Concluído',
    SETTLED: 'Quitada',
    PARTIALLY_SETTLED: 'Quitada parcial',
    PAUSADO: 'Pausado',
    ACE: 'ACE',
    'N/A': 'N/A',
};

interface Props {
    status: string;
    className?: string;
}

const VerificationConfigStatus = ({ status, className = '' }: Props) => {
    const label = LABELS[status] || status || '—';
    const color = getGuaranteeStatusColor(status);
    return (
        <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${color} ${className}`}>{label}</span>
    );
};

export default VerificationConfigStatus;
